import { signal } from 'services/SignalsService'
import { bigWinTime, time } from 'settings/custom/win'
import { delay } from 'utils/Delay'

const name = 'WIN-BIG'

async function execute() {
  const winModel = game.models.WinModel.get()
  const seconds = bigWinTime !== undefined ? bigWinTime : time
  // eslint-disable-next-line no-unused-vars

  await delay(seconds)

  const type = winModel.winType
  const amount = winModel.linesWin

  signal.dispatch('WIN-ANIMATE', type)
  signal.dispatch('WIN-COLLECT', { type, amount })

  return signal.promise('WIN-ANIMATE:DONE')
}

export function getWinBigAction() {
  return {
    name,
    execute,
  }
}
